var path = 'src/app/patients/hospitals/hospitals.html';
var html = "<h1 class=page-header>Hospitals</h1> <div patient-hospitals-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/hospitals/hospitals.html
 ** module id = 489
 ** module chunks = 0
 **/